export interface BlockCreateData {
  title: string;
  type: BlockType;
  orgId: string;
}

export interface BlockParams extends BlockCreateData {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}

export enum BlockType {
  Operation = 'Operation',
  Container = 'Container'
}